import React from 'react';
import { motion } from 'framer-motion';

const SavedValueWidget = ({ value, isDarkMode }) => {
    if (!value || value <= 0) return null;

    return (
        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className={`flex items-center gap-4 p-4 rounded-3xl border ${
                isDarkMode 
                ? 'bg-emerald-900/20 border-emerald-500/30 text-emerald-400' 
                : 'bg-emerald-50 border-emerald-100 text-emerald-600'
            }`}
        >
            <div className={`size-12 rounded-2xl flex items-center justify-center shrink-0 ${
                isDarkMode ? 'bg-emerald-500/20' : 'bg-emerald-500'
            }`}>
                <span className={`material-symbols-outlined ${isDarkMode ? 'text-emerald-400' : 'text-white'}`}>
                    savings
                </span>
            </div>
            <div>
                <p className="text-[10px] font-black uppercase tracking-widest opacity-70">MUTFAK TASARRUFU</p>
                <div className="flex items-end gap-1">
                    <span className="text-2xl font-black tabular-nums">{value.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                    <span className="text-[10px] font-bold mb-1 opacity-60">kurtarıldı</span>
                </div>
            </div>
        </motion.div>
    );
};

export default SavedValueWidget;
